<script>
export default {
  name: 'Notice',
  mounted () {
    this.$emit('setMenu', 'Notice')
  }
}
</script>

<template>
  <div id="notice_wrap">
    <router-view/>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/notice/Notice.vue